import { render, staticRenderFns } from "./PermissionDataRuleModal.vue?vue&type=template&id=03dd99b2&scoped=true"
import script from "./PermissionDataRuleModal.vue?vue&type=script&lang=js"
export * from "./PermissionDataRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dd99b2",
  null
  
)

export default component.exports